import axios from 'axios';

export const newDrugClass = async (drugClass) => {
  const url = `${process.env.REACT_APP_API_URL}/drug_classes`;
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const {data} = await axios.post(url,{...drugClass},{headers: headers});
    return data;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


